import { Button, Container, makeStyles, Theme, Typography } from '@material-ui/core';

import { darkGreen } from 'src/data/colors';

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60vh',
    flexDirection: 'column',
    gap: 20,
  },
  loaderContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorMessage: {
    fontSize: 20,
    margin: '24px 48px 0',
    fontWeight: 'bold',
    whiteSpace: 'pre-line',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 24px',
    },
  },
  button: {
    backgroundColor: 'white',
    border: `1px solid ${darkGreen}`,
    borderRadius: 8,
    color: darkGreen,
    fontSize: 16,
    fontWeight: 500,
    height: 40,
    margin: '0 0 0 5px',
    padding: '8px 16px',
  },
}));

interface Props {
  text: string;
  tryAgain: () => void;
}

const defaultErrorMessage = `There was an error retrieving the site information, please try again later.
If the problem persists, please contact support.`;

const parseErrorMessage = (text: string) => {
  if (!text) {
    return defaultErrorMessage;
  }

  if (text.includes('System.Exception')) {
    return defaultErrorMessage;
  }

  if (text.includes('undefined')) {
    return defaultErrorMessage;
  }

  return text;
};

const EmptyState: React.FC<Props> = ({ text, tryAgain }) => {
  const classes = useStyles();

  const errorMessage = parseErrorMessage(text);

  return (
    <Container className={classes.container}>
      <Typography variant="h3" className={classes.errorMessage}>
        {errorMessage}
      </Typography>

      <Button className={classes.button} onClick={tryAgain}>
        Try again
      </Button>
    </Container>
  );
};

export default EmptyState;
